<template>
  <section class="deletion-form-section">
    <div class="container">
      <SectionHeader
        icon="fas fa-trash-alt"
        title="Richiedi Cancellazione Dati"
        subtitle="Compila il form per richiedere l'eliminazione dei dati conservati sui nostri server"
      />

      <SectionCard>
        <form @submit.prevent="handleSubmit" class="deletion-form">
          <div class="form-fields">
            <div class="form-row">
              <FormInput
                id="deletion-name"
                label="Nome completo"
                v-model="form.name"
                required
                placeholder="Mario Rossi"
              />
              <FormInput
                id="deletion-email"
                label="Email"
                type="email"
                v-model="form.email"
                required
                placeholder="mario.rossi@esempio.com"
              />
            </div>

            <div class="form-group">
              <label for="deletion-type" class="form-label">Tipo di dati da eliminare</label>
              <select
                id="deletion-type"
                v-model="form.dataType"
                required
                class="form-select"
              >
                <option value="" disabled>Seleziona il tipo di dati</option>
                <option value="contact">Dati modulo di contatto</option>
                <option value="navigation">Dati di navigazione del sito web</option>
                <option value="analytics">Dati analitici</option>
                <option value="all">Tutti i dati associati alla mia email</option>
              </select>
            </div>

            <FormTextarea
              id="deletion-details"
              label="Dettagli della richiesta"
              v-model="form.details"
              required
              placeholder="Descrivi i dati che desideri eliminare, includendo eventuali riferimenti (data del contatto, oggetto del messaggio, ecc.)"
              :rows="5"
            />

            <div class="form-checkbox">
              <input
                id="deletion-confirm"
                type="checkbox"
                v-model="form.confirmed"
                required
              />
              <label for="deletion-confirm">
                Confermo di voler procedere con la cancellazione dei dati indicati.
                Comprendo che questa operazione è irreversibile per i dati eliminati
                dai server di ISIGest S.r.l.
              </label>
            </div>
          </div>

          <div class="form-actions">
            <SubmitButton
              text="Invia Richiesta di Cancellazione"
              :disabled="isSubmitting"
            />
          </div>

          <FormMessage
            :message="submitMessage"
            :type="submitMessageClass"
          />
        </form>
      </SectionCard>
    </div>
  </section>
</template>

<script>
import FormInput from '../../components/contattaci/FormInput.vue'
import FormTextarea from '../../components/contattaci/FormTextarea.vue'
import SectionHeader from '../../components/contattaci/SectionHeader.vue'
import SectionCard from '../../components/contattaci/SectionCard.vue'
import SubmitButton from '../../components/contattaci/SubmitButton.vue'
import FormMessage from '../../components/contattaci/FormMessage.vue'

export default {
  name: 'DataDeletionRequestForm',
  components: {
    FormInput,
    FormTextarea,
    SectionHeader,
    SectionCard,
    SubmitButton,
    FormMessage
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        dataType: '',
        details: '',
        confirmed: false
      },
      isSubmitting: false,
      submitMessage: '',
      submitMessageClass: ''
    }
  },
  methods: {
    async handleSubmit() {
      this.isSubmitting = true
      this.submitMessage = ''

      try {
        await new Promise(resolve => setTimeout(resolve, 1500))

        this.submitMessage = 'Richiesta inviata con successo. Ti risponderemo entro 30 giorni lavorativi con la conferma dell\'eliminazione.'
        this.submitMessageClass = 'success'
        this.form = {
          name: '',
          email: '',
          dataType: '',
          details: '',
          confirmed: false
        }
      } catch {
        this.submitMessage = 'Si è verificato un errore. Riprova più tardi o contattaci via email.'
        this.submitMessageClass = 'error'
      } finally {
        this.isSubmitting = false
        setTimeout(() => {
          this.submitMessage = ''
        }, 8000)
      }
    }
  }
}
</script>

<style scoped>
.deletion-form-section {
  padding: 60px 0 100px;
  background-color: #f8f9fa;
}

.deletion-form {
  width: 100%;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.form-group {
  margin-bottom: 24px;
}

.form-label {
  display: block;
  font-size: 0.95rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.form-select {
  width: 100%;
  padding: 14px 16px;
  font-size: 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  background-color: #ffffff;
  color: #1a1f3a;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  appearance: auto;
}

.form-select:focus {
  outline: none;
  border-color: #2a5298;
  box-shadow: 0 0 0 3px rgba(42, 82, 152, 0.15);
}

.form-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 8px;
  margin-bottom: 8px;
}

.form-checkbox input[type="checkbox"] {
  margin-top: 4px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  accent-color: #2a5298;
}

.form-checkbox label {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #4b5563;
}

.form-actions {
  margin-top: 32px;
  text-align: center;
}

@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .deletion-form-section {
    padding: 40px 0 80px;
  }
}
</style>
